<template>
  <div class="fixed-sn">
    <div class="wrapper w-full max-w-none">
      <!-- NAVBAR -->
      <Nav :toggle-sidebar="toggleSidebar" />

      <!-- OVERLAY: mobile only -->
      <Overlay v-if="isSidebarActive" class="lg:hidden" @click="toggleSidebar" />

      <!-- SIDEBAR -->
      <Sidebar :is-active="isSidebarActive" :toggle-sidebar="toggleSidebar" />

      <!-- MAIN CONTENT -->
      <main class="pt-22.5 pb-4 lg:pt-20.5 lg:ml-65 px-4">
        <nav aria-label="breadcrumb" class="my-4">
          <ol class="flex items-center text-sm lg:text-base text-primary-font font-bold leading-none">
            <li v-for="(data, index) in globalBreadcrumb" :key="index" class="flex items-center">
              <!-- separator -->
              <span v-if="index !== 0" class="mx-2 text-primary-font">/</span>

              <!-- item -->
              <component
                :is="data.isSub ? 'router-link' : 'span'"
                :to="data.route"
                class="hover:text-primary transition"
              >
                {{ $t(data.displayName) }}
              </component>
            </li>
          </ol>
        </nav>

        <router-view />
      </main>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Nav from '@/components/Nav.vue';
import Sidebar from '@/components/Sidebar.vue';
import Overlay from '@/components/Overlay.vue';
import MenuData from '@/data/Menu';

export default defineComponent({
  name: 'DefaultLayout',
  // eslint-disable-next-line vue/no-reserved-component-names
  components: { Nav, Sidebar, Overlay },

  data() {
    return {
      globalBreadcrumb: [] as any[],
      isSidebarActive: false
    };
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        this.renderGlobalBreadcrumb();
      }
    }
  },

  mounted() {
    if (window.innerWidth >= 1024) {
      // ~ lg breakpoint
      this.isSidebarActive = false;
    }
  },

  methods: {
    renderGlobalBreadcrumb() {
      this.globalBreadcrumb = [];
      const { menuList } = MenuData as any;
      let current: any;

      menuList.every((element: any) => {
        if (element.route === this.$route.path) {
          current = { ...element };
          return false;
        }
        if ('child' in element) {
          const child = element.child.find((menu: any) => menu.route === this.$route.path);
          if (child) {
            current = child;
            return false;
          }
        }
        return true;
      });

      if (current && 'parentName' in current) {
        const type = typeof current.parentName;
        if (type === 'string') {
          const parent: any = (menuList as any[]).find((menu: any) => menu.name === current.parentName);
          if (parent) this.globalBreadcrumb.push(parent);
        } else if (type === 'object' && Array.isArray(current.parentName)) {
          const parent: any = (menuList as any[]).find((menu: any) => menu.name === current.parentName[0]);
          const sub: any = parent?.child?.find((menu: any) => menu.name === current.parentName[1]);
          if (parent && sub) {
            sub.isSub = true;
            this.globalBreadcrumb.push(parent, sub);
          }
        }
      }

      if (current) {
        this.globalBreadcrumb.push(current);
      }
    },

    toggleSidebar() {
      this.isSidebarActive = !this.isSidebarActive;
    }
  }
});
</script>
